import { render, staticRenderFns } from "./SimpleBar.vue?vue&type=template&id=5f3760d6&scoped=true"
import script from "./SimpleBar.vue?vue&type=script&lang=js"
export * from "./SimpleBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3760d6",
  null
  
)

export default component.exports